// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"FloorTooltip_tooltip__343w5","leftTooltip":"FloorTooltip_leftTooltip__MxNw0","rightTooltip":"FloorTooltip_rightTooltip__HWTjr"};